module.exports = __webpack_public_path__ + "img/sec2.1.c1e09988.png";